import { render } from "./AuthIndex.vue?vue&type=template&id=af25b9d0"
import script from "./AuthIndex.vue?vue&type=script&lang=js"
export * from "./AuthIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__